"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("./util");
function getVariablesFeedbackLetter(move, consultant) {
    return {
        rechnung: util_1.getAddressVariables(util_1.getInvoiceAddress(move)),
        unterschrift: util_1.getSignature(consultant),
    };
}
exports.default = getVariablesFeedbackLetter;
//# sourceMappingURL=feedbackLetter.js.map